var React = require('react');

function Right (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icons / chevron / right"),React.createElement("g",{"id":"icons-/-chevron-/-right","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("polygon",{"id":"chevron-right","fill":"currentColor","transform":"translate(11.997000, 12.000500) scale(-1, 1) rotate(90.000000) translate(-11.997000, -12.000500) ","points":"19.29 6.94 11.996 14.234 4.704 6.94 3.29 8.355 11.996 17.061 20.704 8.355"}))]);
}

Right.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"};

module.exports = Right;

Right.default = Right;
